import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { BannerModerationInfo, setBannerModerationInfo, setIsLoading } from 'store/models/moderation';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type FetchBannerModerationInfo = (props: { bannerId: number; callback: () => void }) => AppThunkAction;

export const fetchBannerModerationInfo: FetchBannerModerationInfo = ({ bannerId, callback }) => {
    return async (dispatch) => {
        try {
            dispatch(setIsLoading(true));

            const bannerInfo = await fetcher.get<unknown, BannerModerationInfo>(
                `/api/v1/moderation/info/banner/${bannerId}`
            );

            dispatch(setBannerModerationInfo(bannerInfo));
            callback();
        } catch (_) {
            dispatch(addMagritteNotification(MagritteNotificationName.BannerModerationInfoSomethingWentWrongError));
        } finally {
            dispatch(setIsLoading(false));
        }
    };
};
